import * as React from 'react';
import { RichTextEditor } from 'mui-tiptap';
import Extension from '@tiptap/starter-kit';
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  MenuButtonBulletedList,
  MenuButtonOrderedList,
  MenuButtonBlockquote,
  type RichTextEditorRef,
} from 'mui-tiptap';

import './RichText.css';

interface RichTextEditorProps {
  content: string;
  onChange?: (content: string) => void;
  editable?: boolean;
}

export const RichText: React.FC<RichTextEditorProps> = ({
  content,
  onChange,
  editable = false,
}) => {
  const rteRef = React.useRef<RichTextEditorRef>(null);

  // Handle content changes
  const handleChange = React.useCallback(() => {
    const editor = rteRef.current?.editor;
    if (editor && onChange) {
      onChange(editor.getHTML());
    }
  }, [onChange]);

  // Update editor content when content prop changes
  React.useEffect(() => {
    const editor = rteRef.current?.editor;
    if (editor && editor.getHTML() !== content) {
      editor.commands.setContent(content);
    }
  }, [content]);

  return (
    <RichTextEditor
      ref={rteRef}
      extensions={[Extension]}
      content={content}
      editable={editable}
      onUpdate={handleChange}
      className="rich-text-editor"
      renderControls={() => {
        if (editable) {
          return (
            <MenuControlsContainer>
              <MenuSelectHeading />
              <MenuDivider />
              <MenuButtonBold />
              <MenuButtonItalic />
              <MenuButtonBulletedList />
              <MenuButtonOrderedList />
              <MenuButtonBlockquote />
            </MenuControlsContainer>
          );
        }
        return null;
      }}
    />
  );
};
